<template>
  <div>
    <card>
      <div slot="header" class='toolsBar'>
        <div class="leftTools" />
        <div>
          <l-button type="info" @click="handlenew()" class='text-right'>新增</l-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <el-table :data="tableData">
            <el-table-column label="排序">
              <div slot-scope="props">
                <b class="font-weight-light">{{props.row.sort}}</b>
              </div>
            </el-table-column>
            <el-table-column label="縮圖">
              <div class='imageCol' slot-scope="props">
                <img v-bind:src="props.row.picUrl" />
              </div>
            </el-table-column>
            <el-table-column label="連結">
              <a slot-scope="props" v-bind:link="props.row.link">{{props.row.link}}</a>
            </el-table-column>
            <el-table-column label="Actions">
              <div class="td-actions" slot-scope="props">
                <a v-tooltip.top-center="'編輯'" class="btn btn-default btn-link btn-xs" @click="handleEdit(props.row)">
                  <i class="fa fa-edit" />
                </a>
                <a v-tooltip.top-center="'刪除'" class="btn btn-danger btn-link btn-xs" @click="handleDelete(props.row.id, props)">
                  <i class="fa fa-close" style='color:red' />
                </a>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <div class="">
          <p class="card-category" />
        </div>
        <l-pagination class="pagination-no-border"
                      v-model="pagination.currentPage"
                      :per-page="pagination.perPage"
                      @input='handleIndexChange'
                      :total="pagination.total" />
      </div>
    </card>
    <el-dialog center :title="getTitle()" :visible.sync="modals.custom">
      <img src="static/img/default-image.jpg" v-show="form.picUrl ==''" width='400px' />
      <img v-bind:src="form.picUrl" v-show="form.picUrl !==''" width='400px' />
      <input class="d-block mb-4" type='file' @change="imgUpload" />
      <fg-input label="連結"
                type="text"
                name="link"
                data-vv-as="連結"
                v-model="form.link"
                v-validate="'required'"     
                :error="getError('link')"
                required />
      <fg-input label="排序"
                type="text"
                name="sort"
                data-vv-as="排序"
                v-model="form.sort"
                v-validate="'required|decimal:1'"    
                :error="getError('sort')"
                required />
      <div class="mt-4"><b>圖片SEO</b></div>
      <hr style='margin-top:5px;border-width:2px;' />
      <fg-input label="圖片標題"
                type="text"
                name="title"
                data-vv-as="圖片標題"
                v-model="form.title" />
      <fg-input label="圖片描述"
                type="text"
                name="title"
                data-vv-as="圖片描述"
                v-model="form.description" />
      <div class="text-right">
        <button type="submit" @click.prevent="validate" class="btn btn-fill btn-info align-right">送出</button>
      </div>
    </el-dialog>
  </div>
</template>


<script>
 /* eslint-disable */ 
  import { DatePicker, Dialog, Table, TableColumn, MessageBox, Select, Option } from 'element-ui'
  import { Checkbox } from 'src/components/index'
  import { Pagination as LPagination } from 'src/components/index'
  import lib from '../../../lib'
  import tools from '../../../tools'

  export default {
    components: {
      [DatePicker.name]: DatePicker,
      [Select.name]: Select,
      [Option.name]: Option,
      [Dialog.name]: Dialog,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn,
      [Checkbox.name]: Checkbox,
      LPagination
    },
    data() {
      return {
        pagination: {
          perPage: 10,
          currentPage: 1,
          total: 0
        },
        form: {
          id: '',
          link: '',
          title: '',
          description: '',
          picUrl: '',
          sort:''
        },
        searchForm: {
          startDt:'',
          endDt:'',
          name:'',
          status:'',
        },
        image: {
          file: null
        },
        query: {
        },
        imageLoader:'',
        modals: {
          custom: false
        },
        tableData: []
      }
    },
    async mounted() {
     await this.getData()
    },
    watch: {
    },
    computed: {
    },
    methods: {
      getStatusText(row, idx) {
        var status = row.status
        for (var i=0 ; i < this.statusOptions.length ; i++) {
          if (this.statusOptions[i]['status'] == status) {
            return this.statusOptions[i]['text']
          }
        }
        return ''
      },
      getTitle() {
        return (this.form.id == '')?'新增輪播':'編輯輪播'
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        var _this = this
        this.$validator.validateAll().then(isValid => {
          if (!isValid) return;
          if (this.form.id === '') {
            _this.create()
          } else {
            _this.update()
          }
        })
      },
      openModal(name) {
        this.modals[name] = true
      },
      closeModal(name) {
        this.modals[name] = false
      },
      async handlenew() {
        await this.clearForm()
        this.$validator.errors.clear()
        this.openModal('custom')
      },
      imgUpload(event) {
        const _this = this
        const file = event.target.files.item(0);
        const reader = new FileReader();
        reader.addEventListener("load", function () {
          _this.form.picUrl = reader.result;
          _this.image.file = file
          event.target.value = ''
        }, false);
        reader.readAsDataURL(file);
      },
      handleEdit(row) {
        this.form.id = row.id
        this.form.link = row.link
        this.form.sort = row.sort
        this.form.picUrl = row.picUrl
        this.form.title = row.title
        this.form.description = row.description
        this.image.file = null
        this.openModal('custom')
      },
      // doSearch(){
      //   this.pagination.currentPage = 1
      //   this.getData()
      // },
      async handleIndexChange(page) {
        await this.getData()
      },
      async getData() {
        this.query.offset = (this.pagination.currentPage - 1) * this.pagination.perPage
        this.query.limit = this.pagination.perPage
        var data = await lib.getBannerList(this.query)
        if (data.status == 0) {
          var result = data.result
          this.pagination.total = result.count
          this.tableData = result.banners
        }
      },
      async clearForm() {
        var _this = this
        return new Promise(function(resolve, reject){
          _this.form.id = ''
          _this.form.link = ''
          _this.form.picUrl = ''
          _this.form.title = ''
          _this.form.description = ''
          _this.form.sort = ''
          _this.image.file = null
          resolve()
        })
      },
      async uploadImage() {
        var data = await lib.uploadImage('banner', this.image.file)
        if (data.status == 0) {
          return data.result.picUrl
        } else {
          return ''
        } 
      },
      async create() {
        if (this.image.file) {
          var image = await this.uploadImage()
          if (image == '') {
            this.$swal('上傳圖片失敗', '', 'error')
            return
          }  
          this.form.picUrl = image
        }
        var data = await lib.createBanner(this.form);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('新增成功', '', 'success')
        } else {
          this.$swal('新增失敗', '', 'error')
        }
      },
      async update() {
        if (this.image.file) {
          var image = await this.uploadImage()
          if (image == '') {
            this.$swal('上傳圖片失敗', '', 'error')
            return
          }  
          this.form.picUrl = image
        }
        var data = await lib.updateBanner(this.form.id, this.form);
        if (data.status == 0) {
          await this.getData()
          this.closeModal('custom')
          this.$swal('更新成功', '', 'success')
        } else {
          this.$swal('更新失敗', '', 'error')
        }
      },
      async handleDelete(id, porp) {
        var result = await tools.confirmDialog(this, "確定要刪除?");
        if (result) {
          var data = await lib.deleteBanner(id)
          if (data.status == 0) {
            await this.getData()
            this.$swal('已刪除', '', 'success')
          } else {
            this.$swal('刪除失敗', '', 'error')
          }
        }
      }
    }
  }
</script>


<style>
.toolsBar {
  justify-content: space-between;
  display: flex;
}

.leftTools {
  display: flex;
}


.leftTools > * {
  padding-right: 10px;
}

.imageCol > img {
  height: 150px;
}
</style>
